import { Component } from '@angular/core';
import { UserdataJunctureComponent } from '../userdata-juncture/userdata-juncture.component';
import { ValidationService, ToastService, DataService, LoadscreenService } from '@core/services';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-noworlater-juncture',
  templateUrl: './noworlater-juncture.component.html',
  styleUrls: ['./noworlater-juncture.component.scss'],
  standalone: false
})
export class NoworlaterJunctureComponent {
  faCheckCircle = faCheckCircle;
  emailInputFlag = false;
  _emailAddressInputIsValid = false;
  validationStarted = false;

  contactInfoForm = new UntypedFormGroup({
    _emailAddressInput: new UntypedFormControl('')
  });

  constructor(private UserdataJuncture: UserdataJunctureComponent, public ValidationService: ValidationService, private api: APIClient, public ToastService: ToastService, public DataService: DataService, public LoadscreenService : LoadscreenService, private router: Router,
              private translate: TranslateService) { }

  continueNow() {
    this.UserdataJuncture.continueNow = true;
  }
  continueLater() {
    this.UserdataJuncture.continueNow = false;
    this.emailInputFlag = true;
  }

  savePerson() {
    this.LoadscreenService.initiateLoading(this.translate.instant('junctures.nowOrLater.pleaseWait'));
    this.validationStarted = true;
    this.emailValidation(this.contactInfoForm.value['_emailAddressInput']);

    if(this._emailAddressInputIsValid) {
      let newData = {
        koopFrameContractId: this.DataService.HIPInsuredPersonFromHIPDto.koopFrameContractId,
        contractorName: this.DataService.HIPInsuredPersonFromHIPDto.contractorName,
        linkType: this.DataService.connectionLinkType,
        contractGroupId: this.DataService.HIPInsuredPersonFromHIPDto.contractGroupId,
        contractGroupName: this.DataService.HIPInsuredPersonFromHIPDto.contractGroupName,
        contractGroupSubName: this.DataService.HIPInsuredPersonFromHIPDto.contractGroupSubName,
        contractGroupFirstLevelRisksName: this.DataService.HIPInsuredPersonFromHIPDto.contractGroupFirstLevelRisksName,
        isAdult: this.DataService.HIPInsuredPersonFromHIPDto.isAdult,
        couponCode: this.DataService.HIPInsuredPersonFromHIPDto.couponCode,
        insuredPerson: {email: this.contactInfoForm.value['_emailAddressInput']} as any,
        state: 'INTERRUPTED'
      };

      const savedBirthDate = sessionStorage.getItem('birthDay');
      if (savedBirthDate) {
        newData.insuredPerson = {
          ...newData.insuredPerson,
          birthDate: savedBirthDate
        };
      }

      this.api.saveInsuredPersonFromHip({insuredPerson: newData}).subscribe(response => {
        this.LoadscreenService.cancelLoading();
        this.router.navigate(['continues-later']);
      }, error => {
        this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
        this.LoadscreenService.cancelLoading();
      });
    }
  }

  emailValidation(input: string) {
    if(this.ValidationService.emailValidator(input)) {
      this._emailAddressInputIsValid = true;
    } else {
      this._emailAddressInputIsValid = false;
    }
  }
}
